module.exports = __webpack_public_path__ + "static/media/violin.c0ed570a.jpeg";